import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'
import { Button, Col, Input, message, Pagination, Row, Table } from 'antd'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import GlobalCss from '@/global.module.less'
import css from './add-dataset-to-task.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import SearchInput from '@/pages/components/SearchInput/SearchInput'

function MountDatasetToTaskModal(props: any) {
  const { open, setOpen, actionCallback, exercise } = props
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(10)
  const [total, setTotal] = useState(0)
  const [datasource, setDatasource] = useState([])
  const [rowSelectedKeys, setRowSelectedKeys] = useState([])

  const onOk = () => {
    let data = {
      exercise_id: exercise?.id,
      dataset_id_list: JSON.stringify(rowSelectedKeys),
    }

    sendHttpPostRequest(
      'exercise/api/oam_mount_public_datasets/',
      data,
      (res) => {
        if (res.code == 0) {
          message.success('挂载成功~')
          setRowSelectedKeys([])
          query.current = ''
          page.current = 1
          actionCallback && actionCallback()
        } else {
          message.error(res.message)
        }
      }
    )

    setOpen(false)
  }

  const onCancel = () => {
    setRowSelectedKeys([])
    setOpen(false)
    query.current = ''
    page.current = 1
  }

  const getDatasetList = () => {
    let data = {
      query: query.current,
      page: page.current,
      pagesize: pageSize.current,
      dataset_type: '2',
    }
    sendHttpPostRequest('dataset/api/oam_query_dataset_list/', data, (res) => {
      if (res.code == 0) {
        setDatasource(res.query_list)
        setTotal(res.total_sum)
      }
    })
  }

  useEffect(() => {
    getDatasetList()
    return () => {}
  }, [])

  const tableRowSelection = {
    selectedRowKeys: rowSelectedKeys,
    getCheckboxProps: (record: any) => ({
      disabled: exercise?.mounted_datasets.some(
        (item) => record.id == item.dataset_id
      ),
    }),
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setRowSelectedKeys(selectedRowKeys)
    },
  }
  const onPageChange = (np, nps) => {
    page.current = np
    pageSize.current = nps
    getDatasetList()
  }

  const cols = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
    },
    {
      title: '数据集名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
  ]

  const AddDatasetToTaskModalContent = (
    <div>
      <Row align={'middle'} justify={'end'} style={{ marginBottom: '20px' }}>
        <Col>
          <SearchInput
            placeholder="搜索数据集"
            width={224}
            onChange={(e) => {
              query.current = e.target.value
            }}
            onSearch={() => {
              page.current = 1
              getDatasetList()
            }}
          />
        </Col>
      </Row>
      <div className={GlobalCss.tableWrapper}>
        <Table
          dataSource={datasource}
          columns={cols}
          pagination={false}
          rowKey={(r) => r.id}
          rowSelection={tableRowSelection}
        />
      </div>
      <div className={GlobalCss.pagination}></div>
    </div>
  )

  return (
    <ModalDrag
      width={720}
      modalTitle={'添加到任务'}
      modalContent={AddDatasetToTaskModalContent}
      open={open}
      onCancel={() => setOpen(false)}
      footer={
        <Row align={'middle'} justify={'space-between'}>
          <Col>
            {' '}
            <Pagination
              current={page.current}
              pageSize={pageSize.current}
              total={total}
              onChange={onPageChange}
              hideOnSinglePage
              showSizeChanger={false}
            />
          </Col>
          <Col className={GlobalCss.ColFlex} style={{ gap: '10px' }}>
            <Button type="default" onClick={onCancel}>
              取消
            </Button>
            <Button onClick={onOk} type="primary" style={{ margin: '0px' }}>
              确定
            </Button>
          </Col>
        </Row>
      }
    />
  )
}

export default MountDatasetToTaskModal
